import { omit } from "underscore"
import moment_timezone from "moment-timezone"

export const enhanceGame = game => {
  const enhancedLocation = JSON.parse(game.location)
  return {
    ...omit(game, "location"),
    location: enhancedLocation
  }
}

export const enhanceLocation = location => {
  const new_suburb = (location.ssc_name).replace(/ *\([^)]*\) */g, "")
  const displayName = `${new_suburb} [${location.state}]`
  const enhancedLocation = Object.assign(location, { suburb_only: new_suburb, display_name: displayName })
  return enhancedLocation
}

const timezones = {
  WA: "Australia/Perth",
  NSW: "Australia/Sydney",
  SA: "Australia/Adelaide",
  TAS: "Australia/Hobart",
  NT: "Australia/Darwin",
  ACT: "Australia/Sydney",
  QLD: "Australia/Brisbane",
  VIC: "Australia/Melbourne"
}

export const getTimeZone = (state) => {
  console.log(state)
  console.log(timezones[state])
  return timezones[state]
}

export const timeZoneConverter = () => {
  console.log(moment_timezone.tz.zonesForCountry("AU"))
}

export const titleize = (sentence) => {
  if (!sentence.split) return sentence
  var _titleizeWord = function (string) {
    // eslint-disable-next-line indent
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
    // eslint-disable-next-line indent
  },
    result = []
  sentence.split(" ").forEach(function (w) {
    result.push(_titleizeWord(w))
  })
  return result.join(" ")
}